// extracted by mini-css-extract-plugin
module.exports = {"services":"Services_services__2IUuW","footer":"Services_footer__2slr4"};